'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = withDefinition;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Generates a function when given a resource definition that will transform the resource's state in redux into a prop for the component

var _metaTag = exports._metaTag = Symbol('redux.supermodel.resource');

function withDefinition(name) {
  var definition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _definition$defaultPa = definition.defaultPayload,
      defaultPayload = _definition$defaultPa === undefined ? {} : _definition$defaultPa;


  return function mapResourceStateToProps(state) {
    var mapOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var mountedAt = mapOptions.mountedAt || 'resource';
    var resource = state[mountedAt] && state[mountedAt][name];

    if (!resource || !resource.initialized && !resource.busy && !resource.error) {
      return _defineProperty({ payload: defaultPayload }, _metaTag, true);
    }

    var pendingAction = resource.busy && resource.meta && resource.meta.action;
    return _extends({}, resource, _defineProperty({
      payload: resource.payload || defaultPayload,
      ready: !resource.busy,
      pendingFetch: pendingAction === 'fetch',
      pendingCreate: pendingAction === 'create',
      pendingUpdate: pendingAction === 'update',
      pendingDestroy: pendingAction === 'destroy'
    }, _metaTag, true));
  };
}


//////////////////
// WEBPACK FOOTER
// ../dist/mapResourceStateToProps.js
// module id = 329
// module chunks = 0